// extracted by mini-css-extract-plugin
export default {"interviews-wrapper":"InterviewsSection_interviews-wrapper__I8EEo","cards-grid":"InterviewsSection_cards-grid__I5MIz","btn-container":"InterviewsSection_btn-container__jQnBb"};